import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { Timepicker, type TimepickerProps } from 'timepicker-ui-react';

import { Box } from '@mui/material';

interface TimePickerProps {
  value: Dayjs | null;
  onChange: (value: Dayjs | null) => void;
}

const TimePicker = ({ value, onChange }: TimePickerProps) => {
  const morning = new Date();
  morning.setHours(0, 0, 0, 0);

  const options: TimepickerProps['options'] = {
    behavior: {
      delayHandler: 50,
    },
    clock: {
      type: '12h',
      incrementMinutes: 15,
      autoSwitchToMinutes: true,
      disabledTime: {
        minutes: ['5', '10', '20', '25', '35', '40', '50', '55'],
      },
      currentTime: {
        time: morning,
      },
    },
    ui: {
      animation: false,
      cssClass: 'busman-timepicker-theme',
    },
  };
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-block',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        width: '100%',
      }}>
      <Box sx={{ position: 'relative', width: '100%' }}>
        <Timepicker
          placeholder="Select time"
          value={value ? value.format('hh:mm A') : ''}
          style={{
            minWidth: 50,
            padding: '8px',
            width: '100%',
            border: '1px solid',
            borderColor: '#F2F2F2',
          }}
          options={options}
          onConfirm={async (data) => {
            const hour12 = Number(data.hour);
            const minutes = Number(data.minutes);

            // Convert 12-hour to 24-hour
            let hour24 = hour12 % 12;
            if (data.type === 'PM') {
              hour24 += 12;
            }

            const baseDate = value || dayjs();
            await onChange(baseDate.hour(hour24).minute(minutes).second(0).millisecond(0));
          }}
        />
      </Box>
    </Box>
  );
};

export default TimePicker;
